import { useFetch } from "hooks/useFetch"
import { BaseMmsEntityServiceInterface } from "interfaces/base-entity-service-interface"
import { FetchExternalApiProps } from "types/mms-base"
import { FetchApiProps } from "../../../types/api"

/*
const useMmsFetchService = (
    apiUrl: string,
    props: FetchExternalApiProps
): FetchApiProps => {
    const { endpoint, options = {} } = props

    const url = apiUrl + endpoint

    // Ajout du header `organization`
    const newOptions: RequestInit = { ...options }
    if (typeof window !== "undefined") {
        const orgId = sessionStorage.getItem("organizationId")
        if (orgId) {
            const existingHeaders = new Headers(options.headers || undefined)
            // Si vous préférez un header custom, utilisez `X-Organization-Id`
            existingHeaders.set("organization", orgId)
            newOptions.headers = existingHeaders
        }
    }

    return useFetch(url, newOptions)
}
*/

export class BaseMmsExternalService
    implements BaseMmsEntityServiceInterface<FetchExternalApiProps>
{
    apiUrl: string

    protected constructor(apiUrl: string) {
        this.apiUrl = apiUrl
    }

    public useFetchService = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options } = props
        const url = this.apiUrl + endpoint
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useFetch(url, options)
    }

    public get = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options = {} } = props
        return this.useFetchService({
            endpoint,
            options: { ...options, method: "GET" },
        })
    }

    public post = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options = {} } = props
        return this.useFetchService({
            endpoint,
            options: { ...options, method: "POST" },
        })
    }

    public put = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options = {} } = props
        return this.useFetchService({
            endpoint,
            options: { ...options, method: "PUT" },
        })
    }

    public patch = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options = {} } = props
        return this.useFetchService({
            endpoint,
            options: { ...options, method: "PATCH" },
        })
    }

    public delete = (props: FetchExternalApiProps): FetchApiProps => {
        const { endpoint, options = {} } = props
        return this.useFetchService({
            endpoint,
            options: { ...options, method: "DELETE" },
        })
    }
}
